import { Session } from '@benzinga/session';
import { camelCaseKeys } from '@benzinga/utils';
import type { News, NodeCategory } from '@benzinga/basic-news-manager';
import type { StoryObject } from '@benzinga/advanced-news-manager';
import type { ArticleData } from './entities/article';

export const isSponsoredArticle = (article: ArticleData | News | StoryObject): boolean => {
  if (article) {
    const articleMeta = article?.meta ? camelCaseKeys<any>(article?.meta) : {};
    const showAdvertiserDisclosure = articleMeta?.flags?.showAdvertiserDisclosure || false;
    const tags = article.tags?.map((tag: NodeCategory) => tag.name) ?? [];
    const channels = article.channels?.map((channel: NodeCategory) => channel.name) ?? [];
    const tagsResult = tags.includes('Partner Content');
    const channelsResult = channels.includes('Partner Content');
    return tagsResult || channelsResult || showAdvertiserDisclosure;
  }
  return false;
};

export const getSponsoredContentLabel = (
  article: ArticleData | News | StoryObject,
): { isSponsored: boolean; label: string } => {
  const sponsored = isSponsoredArticle(article);
  let label = '';
  if (sponsored) {
    label = 'Partner Content';
    const articleMeta = article?.meta ? camelCaseKeys<any>(article?.meta) : {};
    const isContributedContent = articleMeta?.flags?.ContributedContent || false;

    if (isContributedContent) {
      label = 'Contributed Partner Content';
    }
  }
  return { isSponsored: sponsored, label: label };
};

export const checkIfIsSponsoredSourceContent = async (articleType: string, session: Session): Promise<boolean> => {
  if (articleType) {
    const { AdvancedNewsManager } = await import('@benzinga/advanced-news-manager');
    const advancedNewsManager = session.getManager(AdvancedNewsManager);
    const contentTypes = await advancedNewsManager.getContentTypes();
    const result = contentTypes.ok;
    if (result) {
      return result?.sponsored?.includes(articleType);
    }
  }
  return false;
};
